import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Switch,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import { useMainWindow } from '~/hooks/useElectronWindow'
import { useLocalStorageObjectKey } from '~/hooks/useLocalStorage'
import { useSharedVariable } from '~/hooks/useSharedVariable'
import MessageBubble from '~/pages/Messaging/MessageBubble'
import { PopupStyle } from '~/pages/Popup/componentStyles/Popup.style'
import { PopupButtons } from '~/pages/Popup/PopupButtons'
import { textStyleKeys } from '~/themes/textStyles'
import { isElectron } from '~/utils/common'
import { removeItemFromQueueById } from '~/utils/popupQueueUtils'

import {
  CallLogDirection,
  Message,
  MessageThread,
  PopupQueueItem,
} from '@mangovoice/types'

export const PopupItemText = (props: {
  queueItem: PopupQueueItem
  totalMessages?: number
}) => {
  const [isPrivacyActive, onTogglePrivacy] = useLocalStorageObjectKey<boolean>({
    storageKey: 'popupSettings',
    keyInObject: 'textPrivacy',
    initialValue: true,
  })

  const { queueItem, totalMessages = 0 } = props
  const { direction } = (queueItem as MessageThread)?.latest_message as Message
  const isFromTeam = direction === CallLogDirection.Outbound

  const { focusMainWindow } = useMainWindow()
  const [messageQueue, setMessageQueue] =
    useSharedVariable<PopupQueueItem[]>('MessageQueue')

  const handleOpenMango = (queueItem: PopupQueueItem) => {
    if (queueItem && isElectron) {
      handleDismissAll()
      focusMainWindow('open-messages')
    }
  }

  const handleDismiss = (queueItem: PopupQueueItem) => {
    if (queueItem && isElectron) {
      setMessageQueue(
        removeItemFromQueueById(messageQueue || [], queueItem._id),
      )
    }
  }

  const handleDismissAll = () => {
    if (isElectron) {
      setMessageQueue([])
    }
  }

  return (
    <>
      <Flex display={'flex'} flexDirection={'column'} overflowY={'auto'}>
        <Flex
          alignItems={'flex-end'}
          justifyContent={'space-between'}
          marginBottom={'var(--chakra-space-1)'}
        >
          <Text
            textStyle={textStyleKeys.Body3_Bold}
            noOfLines={1}
            marginBottom={0}
            minHeight={4}
          >
            {`${(queueItem as MessageThread)?.name}:` || 'Unknown Sender:'}
          </Text>
          <Flex
            sx={PopupStyle?.baseStyle?.showHideToggleWrapper}
            alignItems={'center'}
          >
            <FormControl
              display="flex"
              alignItems="center"
              justifyContent={'flex-end'}
              width={'100%'}
            >
              <FormLabel
                htmlFor="hide-show-toggle"
                marginBottom="0"
                marginRight={'var(--chakra-space-1)'}
              >
                <Text
                  noOfLines={1}
                  textStyle={textStyleKeys.Body3}
                  id={'showHideToggle'}
                >
                  Privacy
                </Text>
              </FormLabel>
              <Switch
                id="hide-show-toggle"
                size={'sm'}
                sx={PopupStyle?.baseStyle?.showHideToggle}
                isChecked={isPrivacyActive}
                onChange={() => onTogglePrivacy(!isPrivacyActive)}
              />
            </FormControl>
          </Flex>
        </Flex>
        <Flex
          display={'flex'}
          justifyContent={'space-between'}
          overflowY={'auto'}
        >
          <Box
            style={{
              padding: 'var(--chakra-space-1)',
              filter: isPrivacyActive ? 'blur(3px)' : 'none',
            }}
          >
            <MessageBubble
              overrideMaxWidth={'100%'}
              fromCurrentUser={false}
              isFromTeam={isFromTeam}
              message={(queueItem as MessageThread)?.latest_message as Message}
            />
          </Box>
        </Flex>
      </Flex>
      <PopupButtons
        handleOpenMango={() => handleOpenMango(queueItem)}
        handleDismiss={() => handleDismiss(queueItem)}
        mainButtonText={'Open Texts'}
        secondaryButtonText={totalMessages === 1 ? 'Done' : 'Next'}
        handleDismissAll={totalMessages > 1 ? handleDismissAll : undefined}
      />
    </>
  )
}
